/**
 * Canonical URLs for the legal documents hosted on the marketing site. The
 * marketing site is the legally operative copy, so the app never inlines this
 * text — it links out (see LegalLinkService for how that opens on native).
 */
export const TERMS_OF_SERVICE_URL = 'https://www.tablesready.com/terms';
export const PRIVACY_POLICY_URL = 'https://www.tablesready.com/privacy';
export const COOKIE_NOTICE_URL = 'https://www.tablesready.com/cookies';
